<div fxLayout="row" class="background">

    <div fxFlex="75" fxFlexOffset="12%">
  
      <section id="header">
        <h1 class="h1Header">PEDIDOS RECHAZADOS PAGADOS CON TARJETA</h1>
      </section>
  
      <div fxLayout="row" class="tablaCom">
        <div fxFlex=120 fxFlexOffset="-15%">
          <mat-card class="mat-elevation-z0">
  
            <mat-table [dataSource]="dataSource" class="tabla">
              <!-- Codigo Column -->
              <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef class="table-header"> ID</mat-header-cell>
                <mat-cell *matCellDef="let order" class="table-content">{{order.cdOrder}}</mat-cell>
              </ng-container>
  
              <!-- Store Column -->
              <ng-container matColumnDef="comercio">
                <mat-header-cell *matHeaderCellDef class="table-header">Comercio </mat-header-cell>
                <mat-cell *matCellDef="let order" class="table-content"> {{order.dsStoreName}}</mat-cell>
              </ng-container>
  
              <!-- User Column -->
              <ng-container matColumnDef="usuario">
                <mat-header-cell *matHeaderCellDef class="table-header">Usuario</mat-header-cell>
                <mat-cell *matCellDef="let order" class="table-content"> {{order.dsUserName}}<br> {{order.dsPhone}}
                </mat-cell>
              </ng-container>
  
              <!-- Address Column -->
              <ng-container matColumnDef="direccion">
                <mat-header-cell *matHeaderCellDef class="table-header">Dirección</mat-header-cell>
                <mat-cell *matCellDef="let order" class="table-content"> {{order.dsAddress}} </mat-cell>
              </ng-container>
  
              <!-- Items Column -->
              <ng-container matColumnDef="items">
                <mat-header-cell *matHeaderCellDef class="table-header"> Items</mat-header-cell>
                <mat-cell *matCellDef="let order" class="table-content">
                  <button mat-button (click)="openOrder(order.cdOrder)">Ver</button>
                </mat-cell>
              </ng-container>
  
              <!-- total Column  -->
              <ng-container matColumnDef="total">
                <mat-header-cell *matHeaderCellDef class="table-header">Total</mat-header-cell>
                <mat-cell *matCellDef="let order" class="table-content">{{order.qtTotal}}</mat-cell>
              </ng-container>
  
              <!-- Options Column -->
  
              <ng-container matColumnDef="opciones">
                <mat-header-cell *matHeaderCellDef class="table-header">Fecha Cancelación</mat-header-cell>
                <mat-cell *matCellDef="let order" class="table-content">
                  <p class="rejected">Rechazado</p>
                  <div class="detail">{{order.dtUpdatedAt | date:'HH:mm dd-MM-yyyy'}}</div>
                </mat-cell>
              </ng-container>
  
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  
            </mat-table>
  
            
          </mat-card>
        </div>
      </div>
    </div>
  
  </div>
  
